/* esm.sh - applesauce-common@5.2.0/operations/calendar */
export * from "/*applesauce-common@5.2.0/esnext/operations/calendar.mjs";
